//messages.js
export default {
    people_id: "People Id",
    prefix: "Prefix",
    first_name: "First Name",
    middle_name: "Middle Name",
    last_name: "Last Name",
    suffix: "Suffix",
    combined_name: "Combined Name",
    nick_name: "Nick Name",
    job_title: "Job Title",
    gender: "Gender",
    photo_id: "Photo Id",
    photo: "Photo",
    entity_phones_id: "Entity Phones Id",
    entity_emails_id: "Entity Emails Id",
    battery_notify: "Battery Notify",
    user_time_zone: "User Time Zone",
    unit_of_measure: "Unit Of Measure",
    theme: "Theme",
    notification_method: "Notification Method",
    language: "Language",
    invite_token: "Invite Token",
    invite_expires: "Invite Expires",
    edit_person: "Edit Person",
    add_person: "Add Person",
    delete_person: "Delete Person",
    people: "People",
    delete_person_confirm: "This action is not reversible!",
    permissions: "Permissions",
    view_notification: "View Notification",
};
